export default __webpack_public_path__ + "static/media/tensorflow-tf.d7aaf40f.svg";